module.exports = __webpack_public_path__ + "static/media/eye.7b5244ee.svg";